import { ImageResource } from "../../ResourceManager/ImageResource";
import { Resourceful } from "../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { Translator } from "../../Translator";
import { SetStyles } from "../.././MyHelpers";
import { PickBonusParams } from "./PickBonusParams";
import { Settings, SourcePickbonus } from "../../Settings";

export class LevelInfoMessage  implements Resourceful
{

    protected view:HTMLElement = null;
    protected resid:ResourceIdentifier = null;

    protected logo: HTMLElement = null;
    protected pot: HTMLElement = null;
    protected bonus: HTMLElement = null;
    protected header: HTMLElement = null;
    protected levelInfo: HTMLElement = null;
    protected instruction: HTMLElement = null;
    protected symbol: HTMLElement = null;
    protected footer: HTMLElement = null;

    protected pickImage:ImageResource = null;
	protected potImage:ImageResource = null;
	protected bonusImage:ImageResource = null;
	protected messagePanel:ImageResource = null;
    

    protected params: PickBonusParams = null;


    /* protected commonResourcesBasePath:string = "";
    protected gameResourcesBasePath:string = ""; */

    protected translator:Translator = null;

    constructor(resid: ResourceIdentifier, translator:Translator, params: PickBonusParams)
    {
        this.resid = resid;
        this.params = params;
        this.translator = translator;
        this.resid = params.resid.Add("LevelInfoMessage");


        this.view = document.createElement("div");
        this.view.classList.add(this.resid.Scope());
        this.view.classList.add("LevelMessage");

        SetStyles(this.view,
        {
           
            width: "1300px",
            height: "600px",
			backgroundPosition:"center",
			backgroundRepeat:"no-repeat",
			
            color: "white",
            fontSize: "20px",
            display: "flex",
            flexDirection: "column",
			textShadow: " 0 -1px 0 #fff,0 1px 0 #2e2e2e,0 2px 0 #2c2c2c,0 3px 0 #2a2a2a,0 4px 0 #282828,0 5px 0 #262626,0 6px 0 #242424,0 7px 0 #222,0 8px 0 #202020,0 15px 10px rgba(0, 0, 0, 0.9)",
			//textShadow:"0px 0px 10px blue, 0px 0px 20px blue, 0px 0px 30px blue, 0px 0px 40px blue",
			
			margin:"20px",
			backgroundSize: "100% 100%",
			justifyContent: "center",

        })
        
		
        this.Hide();
        

	}
		
    public PrepareResources(resourceManager: IWriteOnlyResourceManager)
    {
		
		if(Settings.SourcePick == SourcePickbonus.DragonLink)
		{
			//LOAD DIAMOND POT   IF YOU USE 3 SCREEN
        resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "DragonImage/pot.png", this.resid.ScopedResourceName(["pot", "image"])));
		}
		if(Settings.SourcePick == SourcePickbonus.Ortiz)
		{
		//LOAD DIAMOND POT   IF YOU USE 3 SCREEN
			resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath+ "pot.png", this.resid.ScopedResourceName(["pot", "image"])));
		}
	
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "bonus.png", this.resid.ScopedResourceName(["bonus", "image"])));
		resourceManager.Add(new ImageResource(this.params.gameBonusResourcesBasePath + "pick.png", this.resid.ScopedResourceName(["pick", "image"])));
		resourceManager.Add(new ImageResource(this.params.gameBonusResourcesBasePath + "message_background.png", this.resid.ScopedResourceName(["messagepanel", "image"])));

    }

    public ResourcesLoaded(resourceManager: IReadOnlyResourceManager)
    {
        this.view.innerHTML = 
		`
		
			<div class="bonusLogo">
				<div class="pot"></div>
				<div class="bonus"></div>
			</div>
			<div class="levelInfo"></div>
			<div class="instruction"> 
				
			</div>
			<div class="footer"> </div>
        `;
        

        this.pickImage =resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["pick", "image"]));
		this.potImage =resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["pot", "image"]));
		this.bonusImage =resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["bonus", "image"]));
		this.messagePanel =resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["messagepanel", "image"]));
        
		this.SetStyleForLevelMessage();
		this.view.style.background = this.messagePanel.CssBackground();
		//this.view.style.backgroundSize="cover";
		this.view.style.backgroundRepeat="no-repeat";
		this.view.style.backgroundPosition="center";
		this.view.style.backgroundSize="100% 100%";
		
        //this.view.querySelector(".header").appendChild(this.translator.Anchor(() => this.translator.t.welcome));
		this.view.querySelector(".footer").appendChild(this.translator.Anchor(() => this.translator.t.footer));
		let translatedMessage = this.translator.Translate(() => this.translator.t.pickbonus(this.symbol.outerHTML));

        this.view.querySelector(".instruction").appendChild(translatedMessage.location);
        
        

    }

    protected SetStyleForLevelMessage():void
	{

		this.logo = this.view.querySelector(".bonusLogo");
		SetStyles(this.logo,
		{
			//boxSizing:"border-box",
			//border:"2px solid green",
			width:"95%",
			height:"25%",
			display:"flex",
			flexDirection:"row",
			left:"41px",
			position:"relative",
		});
		
		this.pot = this.view.querySelector(".pot");
		SetStyles(this.pot,
		{
			//boxSizing:"border-box",
			//border:"2px solid orange",
			width:"60%",
			height:"100%",
			backgroundImage: this.potImage.CssBackground(),// resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["pot", "image"])).CssBackground(),
			backgroundRepeat: "no-repeat",
			backgroundSize: "contain",
			backgroundPosition:"center",
		});

		this.bonus = this.view.querySelector(".bonus");
		SetStyles(this.bonus,
		{
			//boxSizing:"border-box",
			//border:"2px solid purple",
			width:"40%",
			height:"100%",
			backgroundImage: this.bonusImage.CssBackground(),// resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["bonus", "image"])).CssBackground(),
			backgroundRepeat: "no-repeat",
			backgroundSize: "contain",
			backgroundPosition:"center",
		});

		/* logo.style.height = "45%";
		logo.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["logo", "image"])).CssBackground();
		logo.style.backgroundRepeat = "no-repeat";
		logo.style.backgroundSize = "contain"; */

		// this.header = this.view.querySelector(".header");
		// SetStyles(this.header,
		// {
		// 	//boxSizing:"border-box",
		// 	//border:"2px solid red",
		// 	color:"white",
		// 	fontSize:"60px",
		// 	fontFamily:"NotoSansDisplay-BoldItalic",
		// 	textShadow: " 0 -1px 0 #fff,0 1px 0 #2e2e2e,0 2px 0 #2c2c2c,0 3px 0 #2a2a2a,0 4px 0 #282828,0 5px 0 #262626,0 6px 0 #242424,0 7px 0 #222,0 8px 0 #202020,0 15px 10px rgba(0, 0, 0, 0.9)",
		// 	//textShadow:"0px 0px 10px blue, 0px 0px 20px blue, 0px 0px 30px blue, 0px 0px 40px blue",
			
		// 	width:"100%",
		// 	height:"15%",
		// 	display:"flex",
		// 	justifyContent:"center",
		// 	alignItems:"center",

		// });
		
		this.symbol = document.createElement("span");
		SetStyles(this.symbol,
		{
			//boxSizing:"border-box",
			//border:"2px solid purple",
			width:"13%",
			height:"80%",
			backgroundImage: this.pickImage.CssBackground(),//resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["pick", "image"])).CssBackground(),
			backgroundRepeat: "no-repeat",
			backgroundSize: "contain",
			backgroundPosition:"center",
			display: "inline-block",
    		verticalAlign: "middle",
    		position:"relative",

		});

		
    }

    public View():HTMLElement
    {
        return this.view;
    }

    public Show()
    {
        this.view.style.display = "flex";
    }

    public Hide()
    {
        this.view.style.display = "none";
    }
}

export class LevelInfo1 extends LevelInfoMessage
{
    constructor(resid: ResourceIdentifier, translator:Translator, params: PickBonusParams)
    {
        super(resid, translator, params);

        this.resid = params.resid.Add("LevelInfo1");


    }


    public override async ResourcesLoaded(resourceManager:ResourceManager): Promise<void>
    {

       await super.ResourcesLoaded(resourceManager);
        this.view.querySelector(".levelInfo").appendChild(this.translator.Anchor(() => this.translator.t.level1));

    }
    public override SetStyleForLevelMessage():void
    {
        super.SetStyleForLevelMessage();
        
        this.instruction = this.view.querySelector(".instruction");
		SetStyles(this.instruction,
		{
			//boxSizing:"border-box",
			//border:"2px solid green",
			width:"100%",
			height:"25%",
			color:"white",
			fontSize:"60px",
			fontFamily:"NotoSansDisplay-BoldItalic",
			textShadow: " 0 -1px 0 #fff,0 1px 0 #2e2e2e,0 2px 0 #2c2c2c,0 3px 0 #2a2a2a,0 4px 0 #282828,0 5px 0 #262626,0 6px 0 #242424,0 7px 0 #222,0 8px 0 #202020,0 15px 10px rgba(0, 0, 0, 0.9)",
			//textShadow:"0px 0px 10px blue, 0px 0px 20px blue, 0px 0px 30px blue, 0px 0px 40px blue",
			
			justifyContent:"center",
			alignItems:"center",
			textAlign:"center",
			lineHeight: "234px",
		
        });
        
        this.levelInfo = this.view.querySelector(".levelInfo");
		SetStyles(this.levelInfo,
		{
			//boxSizing:"border-box",
			//border:"2px solid red",
			color:"white",
			fontSize:"60px",
			fontFamily:"NotoSansDisplay-BoldItalic",
			//textShadow:"0px 0px 10px blue, 0px 0px 20px blue, 0px 0px 30px blue, 0px 0px 40px blue",
			
			textShadow: " 0 -1px 0 #fff,0 1px 0 #2e2e2e,0 2px 0 #2c2c2c,0 3px 0 #2a2a2a,0 4px 0 #282828,0 5px 0 #262626,0 6px 0 #242424,0 7px 0 #222,0 8px 0 #202020,0 15px 10px rgba(0, 0, 0, 0.9)",
       	
			width:"100%",
			height:"15%",
			display:"flex",
			justifyContent:"center",
			alignItems:"center",
			textAlign:"center",

        });
        this.footer = this.view.querySelector(".footer");
		SetStyles(this.footer,
		{
			//boxSizing:"border-box",
			//border:"2px solid red",
			color:"white",
			fontSize:"60px",
			fontFamily:"NotoSansDisplay-BoldItalic",
			//textShadow:"0px 0px 10px blue, 0px 0px 20px blue, 0px 0px 30px blue, 0px 0px 40px blue",
			
			textShadow: " 0 -1px 0 #fff,0 1px 0 #2e2e2e,0 2px 0 #2c2c2c,0 3px 0 #2a2a2a,0 4px 0 #282828,0 5px 0 #262626,0 6px 0 #242424,0 7px 0 #222,0 8px 0 #202020,0 15px 10px rgba(0, 0, 0, 0.9)",
			width:"100%",
			height:"15%",
			display:"flex",
			justifyContent:"center",
			alignItems:"center",
			position:"relative",
			top:"40px",

        });
    }

    
}

export class LevelInfo2 extends LevelInfoMessage
{
    constructor(resid: ResourceIdentifier, translator:Translator, params: PickBonusParams)
    {
        super(resid, translator, params);
        this.resid = params.resid.Add("LevelInfo2");
    }


    public override async ResourcesLoaded(resourceManager:ResourceManager): Promise<void>
    {

       await super.ResourcesLoaded(resourceManager);
        this.view.querySelector(".levelInfo").appendChild(this.translator.Anchor(() => this.translator.t.level2));

    }

    public override SetStyleForLevelMessage():void
    {
        super.SetStyleForLevelMessage();
        
        this.instruction = this.view.querySelector(".instruction");
		SetStyles(this.instruction,
		{
			//boxSizing:"border-box",
			//border:"2px solid green",
			width:"100%",
			height:"25%",
			color:"white",
			fontSize:"60px",
			fontFamily:"NotoSansDisplay-BoldItalic",
			textShadow: " 0 -1px 0 #fff,0 1px 0 #2e2e2e,0 2px 0 #2c2c2c,0 3px 0 #2a2a2a,0 4px 0 #282828,0 5px 0 #262626,0 6px 0 #242424,0 7px 0 #222,0 8px 0 #202020,0 15px 10px rgba(0, 0, 0, 0.9)",
       	
			//textShadow:"0px 0px 10px blue, 0px 0px 20px blue, 0px 0px 30px blue, 0px 0px 40px blue",
			
			justifyContent:"center",
			alignItems:"center",
			textAlign:"center",
			lineHeight:"234px"
        });
        
        this.levelInfo = this.view.querySelector(".levelInfo");
		SetStyles(this.levelInfo,
		{
			//boxSizing:"border-box",
			//border:"2px solid red",
			color:"white",
			fontSize:"60px",
			fontFamily:"NotoSansDisplay-BoldItalic",
			textShadow: " 0 -1px 0 #fff,0 1px 0 #2e2e2e,0 2px 0 #2c2c2c,0 3px 0 #2a2a2a,0 4px 0 #282828,0 5px 0 #262626,0 6px 0 #242424,0 7px 0 #222,0 8px 0 #202020,0 15px 10px rgba(0, 0, 0, 0.9)",
       	
			//textShadow:"0px 0px 10px blue, 0px 0px 20px blue, 0px 0px 30px blue, 0px 0px 40px blue",
			
			width:"100%",
			height:"15%",
			display:"flex",
			justifyContent:"center",
			alignItems:"center",
			textAlign:"center",

        });
        this.footer = this.view.querySelector(".footer");
		SetStyles(this.footer,
		{
			//boxSizing:"border-box",
			//border:"2px solid red",
			color:"white",
			fontSize:"60px",
			fontFamily:"NotoSansDisplay-BoldItalic",
			textShadow: " 0 -1px 0 #fff,0 1px 0 #2e2e2e,0 2px 0 #2c2c2c,0 3px 0 #2a2a2a,0 4px 0 #282828,0 5px 0 #262626,0 6px 0 #242424,0 7px 0 #222,0 8px 0 #202020,0 15px 10px rgba(0, 0, 0, 0.9)",
       	
			//textShadow:"0px 0px 10px blue, 0px 0px 20px blue, 0px 0px 30px blue, 0px 0px 40px blue",
			
			width:"100%",
			height:"15%",
			display:"flex",
			justifyContent:"center",
			alignItems:"center",
			position:"relative",
			top:"40px"

        });
    }
}

export class LevelInfo3 extends LevelInfoMessage
{
    constructor(resid: ResourceIdentifier, translator:Translator, params: PickBonusParams)
    {
        super(resid, translator, params);
        this.resid = params.resid.Add("LevelInfo3");
    }

    public override async ResourcesLoaded(resourceManager:ResourceManager): Promise<void>
    {

       await super.ResourcesLoaded(resourceManager);
        this.view.querySelector(".levelInfo").appendChild(this.translator.Anchor(() => this.translator.t.level3));

    }
    public override SetStyleForLevelMessage():void
    {
        super.SetStyleForLevelMessage();
        
        this.instruction = this.view.querySelector(".instruction");
		SetStyles(this.instruction,
		{
			//boxSizing:"border-box",
			//border:"2px solid green",
			width:"100%",
			height:"25%",
			color:"white",
			fontSize:"60px",
			fontFamily:"NotoSansDisplay-BoldItalic",
			textShadow: " 0 -1px 0 #fff,0 1px 0 #2e2e2e,0 2px 0 #2c2c2c,0 3px 0 #2a2a2a,0 4px 0 #282828,0 5px 0 #262626,0 6px 0 #242424,0 7px 0 #222,0 8px 0 #202020,0 15px 10px rgba(0, 0, 0, 0.9)",
			//textShadow:"0px 0px 10px blue, 0px 0px 20px blue, 0px 0px 30px blue, 0px 0px 40px blue",
			
			justifyContent:"center",
			alignItems:"center",
			textAlign:"center",
			lineHeight:"234px"
        });
        
        this.levelInfo = this.view.querySelector(".levelInfo");
		SetStyles(this.levelInfo,
		{
			//boxSizing:"border-box",
			//border:"2px solid red",
			color:"white",
			fontSize:"60px",
			fontFamily:"NotoSansDisplay-BoldItalic",
			textShadow: " 0 -1px 0 #fff,0 1px 0 #2e2e2e,0 2px 0 #2c2c2c,0 3px 0 #2a2a2a,0 4px 0 #282828,0 5px 0 #262626,0 6px 0 #242424,0 7px 0 #222,0 8px 0 #202020,0 15px 10px rgba(0, 0, 0, 0.9)",
       	
			//textShadow:"0px 0px 10px blue, 0px 0px 20px blue, 0px 0px 30px blue, 0px 0px 40px blue",
			
			width:"100%",
			height:"15%",
			display:"flex",
			justifyContent:"center",
			alignItems:"center",
			textAlign:"center",

        });
        this.footer = this.view.querySelector(".footer");
		SetStyles(this.footer,
		{
			//boxSizing:"border-box",
			//border:"2px solid red",
			color:"white",
			fontSize:"60px",
			fontFamily:"NotoSansDisplay-BoldItalic",
			textShadow: " 0 -1px 0 #fff,0 1px 0 #2e2e2e,0 2px 0 #2c2c2c,0 3px 0 #2a2a2a,0 4px 0 #282828,0 5px 0 #262626,0 6px 0 #242424,0 7px 0 #222,0 8px 0 #202020,0 15px 10px rgba(0, 0, 0, 0.9)",
       	
			//textShadow:"0px 0px 10px blue, 0px 0px 20px blue, 0px 0px 30px blue, 0px 0px 40px blue",
			
			width:"100%",
			height:"15%",
			display:"flex",
			justifyContent:"center",
			alignItems:"center",
			position:"relative",
			top:"40px"

        });
    }
}

export class LevelInfo4 extends LevelInfoMessage
{
    constructor(resid: ResourceIdentifier, translator:Translator, params: PickBonusParams)
    {
        super(resid, translator, params);

        this.resid = params.resid.Add("LevelInfo4");
       
    }

    public override async ResourcesLoaded(resourceManager:ResourceManager): Promise<void>
    {

       await super.ResourcesLoaded(resourceManager);

        this.view.innerHTML = 
		`
			
			<div class="bonusLogo">
				<div class="pot"></div>
				<div class="bonus"></div>
			</div>
			<div class="levelInfo"></div>
        `;

        
        // this.pickImage =resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["pick", "image"]));
		// this.potImage =resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["pot", "image"]));
        // this.bonusImage =resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["bonus", "image"]));
        // this.messagePanel =resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["messagepanel", "image"]));
        
        this.SetStyleForLevelMessage();
        //this.view.querySelector(".header").appendChild(this.translator.Anchor(() => this.translator.t.welcome));

        this.view.querySelector(".levelInfo").appendChild(this.translator.Anchor(() => this.translator.t.level4));


        

        /* levelInfo.innerHTML=
        `CONGRATULATIONS YOU HAVE REACHED THE DIAMOND LEVEL.</br>
        FIND THE DIAMOND AND WIN THE DIAMOND POT.</br>
        NOW IS YOUR CHANCE.</br>
        GOOD LUCK`; */

    }

    public override SetStyleForLevelMessage():void{
        super.SetStyleForLevelMessage();

        SetStyles(this.view.querySelector(".levelInfo"),
        {
            color: "white",
            fontSize: "57px",
            fontFamily: "NotoSansDisplay-BoldItalic",
			//textShadow:"blue 2px 2px 10px",
			textShadow: " 0 -1px 0 #fff,0 1px 0 #2e2e2e,0 2px 0 #2c2c2c,0 3px 0 #2a2a2a,0 4px 0 #282828,0 5px 0 #262626,0 6px 0 #242424,0 7px 0 #222,0 8px 0 #202020,0 15px 10px rgba(0, 0, 0, 0.9)",
       	
            width: "100%",
            height: "55%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
            justifyItems: "center",
            textAlign: "center",
        });

    }
}
